import apiRoutes from "../../utils/constants/apiRoutes";
import ApiService from "../apiService";
import handleApiCall from "../handleApi";

export const courseStatisticsService = async () =>
  handleApiCall(() => ApiService.get(apiRoutes.learnerStatisticsDetails));
